import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import UserLink from '../../../User/Link';
import AuthorWatchButton from '../../../Button/AuthorWatchButton';
import { MobileContext } from '../../../Context';
import { useFlag } from '../../../redux/flags/hooks';
import s from './Author.scss';
var Author = function (_a) {
    var author = _a.author, isOwner = _a.isOwner, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var actionbarrr = useFlag('actionbarrr');
    if (!author) {
        return null;
    }
    return (React.createElement("div", { className: c(className, actionbarrr && s['actionbarrr']) },
        React.createElement("span", { className: s['by'] },
            t('deviation.details.by'),
            " "),
        React.createElement(UserLink, { className: s['username'], usernameClassName: s['username-inner'], withTooltip: true, user: author }),
        !isOwner && (React.createElement(React.Fragment, null,
            !isMobile && !actionbarrr && (React.createElement("span", { className: s['pipe'] }, "\u00A0\u00A0\u00A0|\u00A0\u00A0\u00A0")),
            React.createElement(AuthorWatchButton, { author: author })))));
};
Author.displayName = 'Author';
export default Author;
//# sourceMappingURL=Author.js.map